<template>
  <div class="">
    <a class="button is-link is-outlined is-fullwidth" @click="openModal"
      >Ny Kurs</a
    >
    <div class="modal" :class="{ 'is-active': open }">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Ny Kurs</p>
          <button
            class="delete"
            aria-label="close"
            @click="closeModal"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="field">
            <label class="label">Kursnamn</label>
            <div class="control">
              <input
                class="input"
                type="text"
                placeholder="Kursnamn"
                v-model="course.type"
              />
            </div>
          </div>

          <div class="field">
            <label class="label">Tid</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="text"
                placeholder="H.MM - H.MM"
                v-model="course.time"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-clock"></i>
              </span>
            </div>
          </div>

          <div class="field">
            <label class="label">Platser</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="number"
                placeholder="Antal deltagare"
                v-model.number="course.numberOfParticipants"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-male"></i>
              </span>
            </div>
          </div>

          <div class="field">
            <label class="label">Pris</label>
            <div class="control has-icons-left">
              <input
                class="input"
                type="number"
                placeholder="Pris"
                v-model.number="course.price"
              />
              <span class="icon is-small is-left">
                <i class="fas fa-money-bill"></i>
              </span>
            </div>
          </div>

          <div class="field">
            <label class="label">Instruktör</label>
            <div class="control">
              <div class="select">
                <select v-model="course.instructor">
                  <option :value="ins.value" v-for="ins in getLabels()" :key="ins.value">
                    {{ ins.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Från</label>
                <div class="control">
                  <input class="input" type="date" v-model="course.startDate" />
                </div>
              </div>
            </div>

            <div class="column">
              <div class="field">
                <label class="label">Till</label>
                <div class="control">
                  <input
                    class="input"
                    type="date"
                    placeholder="Textarea"
                    v-model="course.endDate"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-danger" @click="closeModal">Avbryt</button>
          <button
            class="button is-success add"
            @click="addCourse"
            :disabled="valid()"
          >
            Lägg till kurs
          </button>
        </footer>
      </div>
      <button class="modal-close is-large" aria-label="close"></button>
    </div>
  </div>
</template>

<script>
import axios from "@/utils/request.js";

export default {
  name: "NewCourse",
  data: function () {
    return {
      open: false,
      course: {},
      instructors: [],
      valid: function () {
        return !(
          !!this.course.type &&
          !!this.course.endDate &&
          !!this.course.startDate &&
          !!this.course.time &&
          !!this.course.numberOfParticipants
        );
      },
    };
  },
  created: function () {
    this.getInstructors();
  },
  methods: {
    openModal() {
      this.open = true;
    },
    closeModal() {
      this.open = false;
    },
    getInstructors: function () {
      axios
        .get("/api/instructors/")
        .then((response) => {
          this.instructors = response.data;
        })
    },
    getLabels: function () {
      var labels = this.instructors.map((ins) => ({
        label: ins.first_name + " " + ins.last_name,
        value: ins._id,
      }));
      labels.push({ value: null, label: "Ingen instruktör" });
      return labels;
    },
    addCourse() {
      axios
        .post("/api/courses/", this.course)
        .then(() => {
          this.$emit("reloadCourses");
          this.closeModal();
        })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.add {
  margin-left: auto;
}

</style>